import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import {
  FETCH_SHARE_LIST,
  FETCH_SHARE_LIST_SUCCESS,
  FETCH_SHARE_LIST_FAIL
} from '../../constants';

const fetchShareList = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_SHARE_LIST),
    switchMap(action => {
      console.log(action.campaignId);
      return ajax({
        url:  `${state$.value.auth.server}/campaigns/${action.campaignId}/sharedaccounts?type=audienceSummary`,
        headers: {
          Authorization: state$.value.auth.token,
          'Content-Type': 'application/json',
        },
        responseType: 'json',
        crossDomain: true,
        method: 'GET',
      }).pipe(
        map(response => {
          return {
            type: FETCH_SHARE_LIST_SUCCESS,
            data: response.response
          };
        }),
        catchError(error =>
          of({
            type: FETCH_SHARE_LIST_SUCCESS,
            data: []
          })
        )
      );
    })
  );

export default fetchShareList;
